import type { StatsigUser } from '@jotpsych/statsig';

import { APP_DEPLOY_VERSION } from '../../config/appVersion';

// Preserve deployment targeting when restoring the anonymous browser identity.
export const ANONYMOUS_STATSIG_USER: StatsigUser = { appVersion: APP_DEPLOY_VERSION };
